import { useToast } from '@chakra-ui/react'
import { upperFirst } from 'lodash'
import { useState } from 'react'

import { requestApi } from '../api/request-handler'
import type { FeedType } from '../types'

export function useSendFeeds(matchId: string, bypassLookup: boolean = false) {
  const toast = useToast()
  const [isSending, setIsSending] = useState(false)

  const sendFeedToast = (type: FeedType, status: 'success' | 'error') => {
    toast({
      title: `${upperFirst(type)} feed ${status === 'success' ? 'sent successfully' : 'send failed'}`,
      status: status,
      duration: 3000,
    })
  }

  const sendFeed = async (type: FeedType, ballId?: string) => {
    setIsSending(true)
    const gameId = matchId.split('_')[0]
    let path = `feed/match/${gameId}`
    let params: { bypasscache?: string } | undefined
    if (type === 'match' && bypassLookup) {
      params = { bypasscache: 'true' }
    }
    if (type === 'allBall') {
      path = `${path}/ball`
    }
    if (type === 'ball' && ballId) {
      path = `${path}/ball/${ballId}`
    }

    try {
      const response = await requestApi(path, {
        method: 'POST',
        params,
      })
      if (response) {
        setIsSending(false)
        sendFeedToast(type, response.ok ? 'success' : 'error')
      }
    } catch (error) {
      console.warn('Error sending Feed', error) // eslint-disable-line no-console
      setIsSending(false)
      sendFeedToast(type, 'error')
    }
  }

  return { isSending, sendFeed }
}
